// src/components/StarUnlockModal.jsx
import React, { useRef } from "react";

export default function StarUnlockModal({
  open,
  starImageSrc,
  completedHeroImageSrc,
  title = "STAR UNLOCKED!",

  // ✅ used by LevelTemplate
  completionTitle = null,
  completionBody = null,

  onCollect,
  onNext,
  canGoNext = false,

  // ✅ NEW: lets LevelTemplate override the green button label
  nextLabel = "Next Level Unlocked →",
}) {
  const starRef = useRef(null);
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* dim */}
      <div className="absolute inset-0 bg-black/55" />

      {/* card */}
      <div className="relative w-[92vw] max-w-md rounded-[28px] bg-white shadow-2xl border border-white/70 overflow-hidden">
        <div className="p-5 flex flex-col items-center text-center gap-3">
          <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500 font-extrabold">
            {title}
          </div>

          {/* Big star */}
          <div
            ref={starRef}
            className="w-28 h-28 rounded-3xl bg-[#FFF7ED] border border-amber-200 shadow-inner flex items-center justify-center animate-[pop_420ms_ease-out_1]"
          >
            <img
              src={starImageSrc}
              alt="Star"
              className="w-20 h-20 object-contain drop-shadow"
            />
          </div>

          {/* Completion text (optional) */}
          {(completionTitle || completionBody) && (
            <div className="w-full rounded-2xl bg-slate-50 border border-slate-200 px-4 py-3">
              {completionTitle && (
                <div className="text-sm sm:text-base font-black text-slate-900">
                  {completionTitle}
                </div>
              )}
              {completionBody && (
                <div className="text-xs sm:text-sm text-slate-600 mt-1">
                  {completionBody}
                </div>
              )}
            </div>
          )}

          {/* Completed hero image */}
          {completedHeroImageSrc && (
            <div className="w-full rounded-2xl overflow-hidden border border-slate-200">
              <img
                src={completedHeroImageSrc}
                alt=""
                className="w-full h-40 object-cover"
                onError={(e) => (e.currentTarget.style.display = "none")}
              />
            </div>
          )}

          {!canGoNext ? (
            <button
              className="mt-1 px-8 py-3 rounded-full bg-[#FFC94E] border-[3px] border-[#456EFF] shadow-[0_6px_0_#E0862B] text-sm font-black uppercase active:translate-y-[2px] active:shadow-[0_4px_0_#E0862B]"
              onClick={() => onCollect?.(starRef.current)}
            >
              ⭐ Collect Star
            </button>
          ) : (
            <button
              className="mt-1 px-8 py-3 rounded-full bg-[#22C55E] text-white shadow-[0_6px_0_#16A34A] text-sm font-black uppercase active:translate-y-[2px] active:shadow-[0_4px_0_#16A34A]"
              onClick={onNext}
            >
              {nextLabel}
            </button>
          )}

          <div className="text-[10px] text-slate-500">
            Tap to collect and add it to your Star Quest meter.
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pop {
          0% { transform: scale(0.75); opacity: 0; }
          60% { transform: scale(1.12); opacity: 1; }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
}
